import { render, staticRenderFns } from "./HOOrderList.vue?vue&type=template&id=280570b8&v-cloak=true&"
import script from "./HOOrderList.vue?vue&type=script&lang=ts&"
export * from "./HOOrderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports